import React, { FC } from 'react';
import {APP} from "../../Utils/Constants.ts";

interface FormationShortageProps {
  value?: Filter|undefined; // Make the value prop optional
  handleFormationShortage: (filterId: any, value: any) => void;
}

const FormationShortage: FC<FormationShortageProps> = ({
                                                         value,
                                                         handleFormationShortage,
                                                       }) => {
  const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFormationShortage(APP.FILTER.SHORTAGE.FIELD, e.target.checked ? [true] : []);
  };

  const id = 'checkbox-shortage';
  const label = 'Métier en pénurie / Fonction critique';

  return (
    <div className={'filter-wrapper others__wrapper'}>
      <div key={id} className={'checkbox-input'}>
        <input
          checked={value?.values?.[0] || false} // Provide a default value of false if value is undefined
          onChange={handleClick}
          id={id}
          name={id}
          type={'checkbox'}
          value={value ? 'true' : 'false'} // Convert boolean to string
        />
        <label htmlFor={id}>{label}</label>
      </div>
    </div>
  );
};

export default FormationShortage;
